import logo from "../img/img.gif";
import "../App.css"; 
import Typewrite from "../components/Typewrite";
import NewNavbar from "../components/NewNavbar";
import Navbar from "../components/Navbar";
import 'animate.css';

// import pdf from '../img/Jonathan_Sapp_Resume_10_29_25.pdf';
import Particles from '../components/Particles';

function App() {
  return (
    <div className="App">
      <header className="App-header">  
      </header>
      <div className="App-header">
        <Particles
          particleColors={['#ffffff', '#ffffff']}
          particleCount={200}
          particleSpread={10}
          speed={0.1}
          particleBaseSize={100}
          moveParticlesOnHover={true}
          alphaParticles={false}
          disableRotation={false}
        />

        <div className="grid grid-cols-2 gap-4 test">

          <div class="py-2 px-10" className="text-center" style={{zIndex: 1}}>
            <h1 className="text-5xl animate__animated animate__fadeInUp">McKenna Oxenden</h1>
            <h2 className="text-3xl animate__animated animate__fadeInUp">Journalist</h2>

            {/* <button class="bg-rose-500 text-white font-bold py-2 px-4 rounded-full my-8" onMouseEnter={console.log("Hello")}>
              <a href = {pdf} target = "_blank" rel="nonreferrer" class="resume">Resume</a>
            </button> */}
          </div>

          <div className="text-left">
            {/* <img src={logo} className="App-logo" alt="logo" /> */}
            {/* <img src={logo} className="App-logo" alt="logo" /> */}
          </div>

        </div>
      </div>
    </div>
  );
}

export default App;